import type { ReactFormExtendedApi } from '@tanstack/react-form';
import {
  DECK_TYPE_CALENDAR,
  FALLBACK_HOLD_LAST_STRIP,
  METHOD_FLAT,
  STRIP_MODE_MOST_RECENT,
  type DeckType,
  type FallbackType,
  type MethodType,
  type StripDateMode,
} from '../types';

// ─────────────────────────────────────
// Form Mode
// ─────────────────────────────────────

export type PriceDeckFormMode = 'create' | 'edit';

// ─────────────────────────────────────
// Form Values
// ─────────────────────────────────────

/** Complete form values managed by TanStack Form */
export interface PriceDeckFormValues {
  name: string;
  description: string;
  methodType: MethodType;
  oilFlatPrice: number | null;
  gasFlatPrice: number | null;
  stripDateMode: StripDateMode;
  stripSource: string | null;
  stripPriceDate: string | null;
  oilStripDuration: number | null;
  oilScaleFactor: number | null;
  oilFallbackType: FallbackType;
  gasStripDuration: number | null;
  gasScaleFactor: number | null;
  gasFallbackType: FallbackType;
  blobPath: string | null;
  originalFilename: string | null;
  deckType: DeckType;
  anchorDate: string | null;
}

/** Default form values for create mode */
export const INITIAL_FORM: PriceDeckFormValues = {
  name: '',
  description: '',
  methodType: METHOD_FLAT,
  oilFlatPrice: null,
  gasFlatPrice: null,
  stripDateMode: STRIP_MODE_MOST_RECENT,
  stripSource: null,
  stripPriceDate: null,
  oilStripDuration: 12,
  oilScaleFactor: 100,
  oilFallbackType: FALLBACK_HOLD_LAST_STRIP,
  gasStripDuration: 12,
  gasScaleFactor: 100,
  gasFallbackType: FALLBACK_HOLD_LAST_STRIP,
  blobPath: null,
  originalFilename: null,
  deckType: DECK_TYPE_CALENDAR,
  anchorDate: null,
};

/** TanStack Form instance type alias (all validator slots unused) */
export type PriceDeckFormInstance = ReactFormExtendedApi<
  PriceDeckFormValues,
  undefined, // TOnMount
  undefined, // TOnChange
  undefined, // TOnChangeAsync
  undefined, // TOnBlur
  undefined, // TOnBlurAsync
  undefined, // TOnSubmit
  undefined, // TOnSubmitAsync
  undefined, // TOnDynamic
  undefined, // TOnDynamicAsync
  undefined, // TOnServer
  undefined // TSubmitMeta
>;
